import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UnitListLayer from "../components/UnitListLayer";

const UnitListPage = () => {
    return (
        <MasterLayout>
            <UnitListLayer />
        </MasterLayout>
    );
};

export default UnitListPage;
